import React, { useState } from "react";
import { Paperclip, Smile, Send } from "lucide-react";
import { Constants } from "../../../../utils/constants";
import logger from "../../../../utils/logger";


const MessageInput = ({ onSendMessage, sendingMessage, disabled = false }) => {
  const [message, setMessage] = useState("");

  // Debug logging
  React.useEffect(() => {
    logger.log("🔧 MessageInput props changed", { disabled, sendingMessage, hasOnSendMessage: !!onSendMessage });
  }, [disabled, sendingMessage, onSendMessage]);

  const handleSubmit = e => {
    e.preventDefault();
    logger.log("📝 MessageInput handleSubmit", {
      message: message.trim(),
      hasMessage: !!message.trim(),
      sendingMessage,
      disabled,
      willCall: !!(message.trim() && !sendingMessage && !disabled),
    });

    if (!message.trim() || sendingMessage || disabled) {
      logger.log("❌ MessageInput: Not calling onSendMessage", {
        reason: !message.trim() ? "empty message" : sendingMessage ? "sending" : "disabled",
      });
      return;
    }

    logger.log("✅ MessageInput: Calling onSendMessage");
    onSendMessage(message.trim());
    setMessage("");
  };

  const handleKeyPress = e => {
    logger.log("⌨️ Key pressed", { key: e.key, shiftKey: e.shiftKey });
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      logger.log("✅ Enter key detected, calling handleSubmit");
      handleSubmit(e);
    }
  };

  return (
    <div className="px-4 py-4 bg-white rounded-b-2xl border-t border-gray-100 md:px-6 md:py-5">
      <form onSubmit={handleSubmit} className="flex items-center space-x-3 md:space-x-4">
        <button type="button" className="p-2 text-gray-400 transition-colors hover:text-gray-600" disabled={disabled}>
          <Paperclip className="w-5 h-5" />
        </button>

        <div className="relative flex-1">
          <input
            type="text"
            value={message}
            onChange={e => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type a message..."
            disabled={disabled || sendingMessage}
            className="px-4 py-3 w-full text-sm placeholder-gray-500 bg-gray-100 rounded-full border-0 md:px-5 md:py-4 focus:outline-none focus:ring-2 focus:ring-opacity-50 md:text-base disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              "--tw-ring-color": Constants.HOST_EXPERIENCE_BASE_COLOR,
            }}
          />
        </div>

        <button type="button" className="p-2 text-gray-400 transition-colors hover:text-gray-600" disabled={disabled}>
          <Smile className="w-5 h-5" />
        </button>

        <button
          type="submit"
          disabled={!message.trim() || sendingMessage || disabled}
          onClick={e => {
            logger.log("🖱️ Send button clicked", {
              message: message.trim(),
              hasMessage: !!message.trim(),
              sendingMessage,
              disabled,
              willSubmit: !!(message.trim() && !sendingMessage && !disabled),
            });
            // Let form handle submission
          }}
          className="p-3 rounded-full transition-colors hover:opacity-80 disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: Constants.HOST_EXPERIENCE_BASE_COLOR }}
        >
          <Send className="w-5 h-5 text-white" />
        </button>
      </form>
    </div>
  );
};

export default MessageInput;
